<template>
  <div class="payment-page">
    <div>
      <b-row>
        <b-col lg="12">
          <b-form-group id="input-group-1" label-for="amt-pay">
            <label class="" id="label-amt-pay">
              <span
                v-if="
                  state.billing.billing.layBy_Amt != 0 &&
                    !refundMode &&
                    !transTypeRefundNote
                "
                >Amount Payable for Lay-by</span
              >
              <span
                v-if="
                  state.billing.billing.layBy_Amt == 0 &&
                    !refundMode &&
                    !transTypeRefundNote
                "
                >Payable Amount</span
              >
              <span v-if="refundMode || transTypeRefundNote"
                >Refund Amount</span
              >
            </label>
            <input
              id="amt-pay"
              ref="amt-pay"
              type="number"
              required
              placeholder=" 0.00"
              :disabled="multiple == false"
              v-model="payableAmt"
              class="form-control amtpay"
              v-allow.decimal.number="payableAmt"
              @blur="sendAmt"
            />
          </b-form-group>
        </b-col>
        <b-col lg="12">
          <b-form-group
            id="input-group-1"
            label-for="amt-pay"
            v-if="
              isOmsMiniAmount.status &&
                $store.state.billing.billing.billing_mode == 'order' &&
                $store.getters.orderPaymentMode
            "
          >
            <!-- <label class="mt-4">
              <span>&nbsp;</span>
            </label> -->
            <div class="d-flex align-items-center text-primary">
               <font-awesome-icon
                    icon="info-circle"
                    v-show="isOrderBtnEnabled"
                  />
                  <font-awesome-icon
                    icon="check-circle"
                    v-show="!isOrderBtnEnabled"
                  />
                 <span class="ml-2" v-text="orderMiniPayMsg"></span>
            </div>
            <!-- <div
              class="input-group mb-3 form-notification"
              :class="[!isOrderBtnEnabled ? 'active-from-notification' : '']"
            >
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">
                 
                </span>
              </div>
              <input
                type="text"
                class="form-control"
                :value="orderMiniPayMsg"
                readonly
              />
            </div> -->
            <!-- <input
              id="amt-pay"
              type="number"
              required
              disabled
              :value="isOmsMiniAmount.amount"
              class="form-control amtpay"
            /> -->
          </b-form-group>
        </b-col>
      </b-row>
      <label
        class="mt-4"
        v-if="refundMode || transTypeRefundNote"
        id="label-for-refund-method"
        >Select Refund Method</label
      >
      <label
        class="mt-2"
        v-if="!refundMode && !transTypeRefundNote"
        id="label-for-payment-method"
        >Select Payment Method</label
      >
      <div class="scroll">
        <b-row v-if="!refundMode && !transTypeRefundNote">
          <b-col>
            <b-row class="paybtns-row">
              <b-col md="6" v-if="checkCash">
                <b-button
                  block
                  variant="outline-secondary"
                  class="text-center p-0 h-25 mb-2"
                  @click="openCashModal('cash')"
                  :disabled="paymentBntDisabled || $loading"
                  id="pay-method-cash"
                >
                  <!-- <img src="@/assets/images/rupee.png" alt="Cash" class="cash-light" /> -->
                  <img src="@/assets/images/cash-dark.svg" alt="Cash" />&nbsp;
                  Cash
                </b-button>
              </b-col>
              <b-col md="6" v-if="checkCard.status">
                <b-button
                  block
                  variant="outline-secondary"
                  class="text-center p-0 h-25 mb-2"
                  @click="openCashModal(checkCard.type)"
                  :disabled="paymentBntDisabled || $loading"
                  id="pay-method-card"
                >
                  <img
                    src="@/assets/images/card-dark.svg"
                    alt="Credit Card"
                  />&nbsp; Card
                </b-button>
              </b-col>
              <b-col md="6" v-if="false">
                <!-- <b-col md="3">-->
                <b-button
                  block
                  variant="outline-secondary"
                  class="text-center p-0 h-25 mb-2 align-item-center"
                  @click="redeemLoyaltyPoints()"
                  :disabled="paymentBntDisabled || $loading"
                  id="pay-method-redeem-coupon"
                >
                  <img
                    src="@/assets/images/giftvoucher.svg"
                    alt="Redeem Coupon"
                  />&nbsp; Redeem Coupon
                </b-button>
              </b-col>
              <b-col md="6" v-if="paytmOffline">
                <b-button
                  class="text-center  p-0 h-25 mb-2"
                  variant="outline-secondary"
                  block
                  @click="openCashModal('paytm_offline')"
                  :disabled="paymentBntDisabled || $loading"
                  id="pay-method-paytm"
                >
                  <img src="@/assets/images/paytm.svg" alt="Paytm" class />
                </b-button>
              </b-col>
              <b-col md="6" v-if="googlePayOffline">
                <b-button
                  class="text-center p-0 h-25 mb-2"
                  variant="outline-secondary"
                  block
                  @click="openCashModal('google_tez_offline')"
                  :disabled="paymentBntDisabled || $loading"
                  id="pay-method-googlepay"
                >
                  <img
                    src="@/assets/images/googlepay.svg"
                    alt="Google Pay"
                    class
                  />
                </b-button>
              </b-col>
              <b-col md="6" v-if="mp200Status">
                <b-button
                  class="text-center p-0 h-25 mb-2"
                  variant="outline-secondary"
                  block
                  @click="openMP200Modal()"
                  :disabled="
                    paymentBntDisabled ||
                      state.system.mp200Port == '' ||
                      $loading
                  "
                  id="pay-method-ezswype-mp200"
                >
                  <p class="m-0">EzSwype MP200</p>
                  <!-- <img src="@/assets/images/googlepay.svg" alt="Google Pay" class /> -->
                </b-button>
              </b-col>
              <b-col md="6" v-if="pinelabStatus">
                <pinelabs :amount="payableAmt"></pinelabs>
              </b-col>
              <b-col md="6" v-if="phonepeStatus">
                <phone-pe :amount="payableAmt" />
              </b-col>
              <b-col md="6" v-if="gvStatus && !state.giftVoucher.isGvSale">
                <redeem-voucher />
              </b-col>
              <!-- <b-col md="3">
          <b-button class="text-center btn btn-white w-100 pl-md-0 pr-md-0">
            <img src="@/assets/images/card.svg" alt="Card" />
            Card
          </b-button>
        </b-col>-->
              <!-- <b-col md="3">
          <b-button class="text-center btn btn-white w-100 pl-md-0 pr-md-0">
            <img src="@/assets/images/gift_voucher.svg" alt="Vocuher" />
            Voucher
          </b-button>
        </b-col>-->
            </b-row>
          </b-col>
        </b-row>
        <hr
          class="mt-0"
          v-if="
            checkOfflineType.length > 0 && !refundMode && !transTypeRefundNote
          "
        />
        <div
          class="row custom-methods"
          v-if="
            checkOfflineType.length > 0 && !refundMode && !transTypeRefundNote
          "
        >
          <b-col md="6" v-for="item in checkOfflineType" :key="item.name">
            <b-button
              class="text-center mb-2"
              variant="outline-secondary"
              block
              :disabled="paymentBntDisabled || $loading"
              @click="openOfflineModal(item.display_name, item.name)"
              :title="item.display_name.length > 15 ? item.display_name : ''"
              :id="'pay-method-' + item.mop_name"
            >
              {{
                item.display_name.length > 15
                  ? item.display_name.slice(0, 15) + ".."
                  : item.display_name
              }}
            </b-button>
          </b-col>
        </div>
        <div
          class="row custom-methods"
          v-if="refundMode || transTypeRefundNote"
        >
          <div class="col-md-6" v-if="refundType.cash">
            <b-button
              block
              variant="outline-secondary"
              class="text-center p-0 h-25 mb-3"
              @click="openRefundModal('Cash')"
              id="open-refund-modal"
              :disabled="$loading"
            >
              <!-- <img src="@/assets/images/rupee.png" alt="Cash" class="cash-light" /> -->
              <img src="@/assets/images/cash-dark.svg" alt="Cash" />&nbsp; Cash
            </b-button>
          </div>
          <div class="col-md-6" v-show="refundType.store_credit">
            <b-button
              block
              variant="outline-secondary"
              class="text-center p-0 h-25 mb-3"
              @click="openRefundModal('Voucher')"
              id="refund-mode-voucher"
              v-if="refundMode"
              :disabled="$loading"
            >
              <!-- <img src="@/assets/images/rupee.png" alt="Cash" class="cash-light" /> -->
              Voucher
            </b-button>
          </div>
        </div>
        <!--  <hr>
      <div class="row">
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/upi_long.svg" alt="UPI" class>
          </b-button>
        </b-col>
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/paytm_long.svg" alt="Paytm" class>
          </b-button>
        </b-col>
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/google_pay_long.svg" alt="Google Pay" class>
          </b-button>
        </b-col>
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/phonepe_long.svg" alt="Phone Pe" class>
          </b-button>
        </b-col>
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/amazonpay_long.png" alt="Amazon Pay" class>
          </b-button>
        </b-col>
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/paypal_long.svg" alt="PayPal" class>
          </b-button>
        </b-col>
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/mobikwik_long.svg" alt="Mobikwik" class>
          </b-button>
        </b-col>
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/freecharge_long.png" alt="Free Charge" class>
          </b-button>
        </b-col>
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/airtel_long.png" alt="Airtel" class>
          </b-button>
        </b-col>
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/citrus_long.svg" alt="Citrus" class>
          </b-button>
        </b-col>
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/ola_long.png" alt="OLA Money" class>
          </b-button>
        </b-col>
        <b-col md="3">
          <b-button class="text-center btn btn-white mb-3 w-100">
            <img src="@/assets/images/payu_long.svg" alt="Pay U" class>
          </b-button>
        </b-col>
      </div>-->
      </div>
    </div>
    <!-- <customer-info-checkout /> -->
    <!-- Cash Modal -->
    <b-modal
      ref="cash-modal"
      :title="title"
      size="sm"
      centered
      @hide="clearData"
      id="pay"
      hide-footer
      :hide-header="$loading == true"
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-form @submit.prevent v-if="$loading == false">
        <b-form-group
          :id="
            refundMode || transTypeRefundNote
              ? 'label-for-refund-amt'
              : 'label-for-customer-paid'
          "
          :label="
            refundMode || transTypeRefundNote
              ? 'Refund Amount'
              : 'Customer Paid'
          "
          label-for="input-1"
        >
          <input
            :id="
              refundMode || transTypeRefundNote
                ? 'input-for-refund-amt'
                : 'input-for-customer-paid'
            "
            type="number"
            size="sm"
            min="0"
            class="form-control"
            autofocus
            autocomplete="off"
            placeholder="Enter Amount"
            v-model="payAmt"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
            :disabled="paymentMethod != 'cash' || $loading"
          />
        </b-form-group>
        <b-form-group
          class="pay"
          id="cash-refund-label"
          label="Balance Amount to be refunded"
          label-for="input-2"
          v-if="paymentMethod == 'cash'"
          @click.enter="makePayment"
        >
          <b-form-input
            id="cash-refund-amount"
            type="number"
            size="sm"
            :value="parseFloat(refundAmt).toFixed(2)"
            autocomplete="off"
            placeholder="0.00"
            readonly
          ></b-form-input>
        </b-form-group>

        <b-button
          variant="primary"
          type="submit"
          @click="makePayment"
          :disabled="btnDisabled || payAmt == '' || $loading"
          id="process-payment-btn"
          class="float-right mt-4"
        >
          <span v-if="!$loading">Continue</span>
          <b-spinner small v-if="$loading"></b-spinner>
        </b-button>
      </b-form>
      <div v-if="$loading" class="m-1">
        <h6 style="font-weight: normal;" v-if="!refundMode">
          Processing Payment
        </h6>
        <h6 style="font-weight: normal;" v-if="refundMode">
          Processing Refund
        </h6>
        <b-progress
          :value="100"
          variant="primary"
          striped
          animated
          class="mt-3"
        />
      </div>
    </b-modal>

    <b-modal
      ref="mp200-modal"
      title="Pay by EzSwype MP200"
      size="sm"
      centered
      @hide="clearData"
      id="mp200-modal"
      hide-footer
      no-close-on-backdrop
      :hide-header="$loading == true"
    >
      <b-form @submit.prevent v-if="$loading == false">
        <b-form-group
          id="label-customer-paid"
          label="Customer Paid"
          label-for="input-1"
        >
          <input
            id="input-customer-paid"
            type="number"
            size="sm"
            min="0"
            class="form-control"
            autofocus
            autocomplete="off"
            placeholder="Enter Amount"
            v-model="payAmt"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
            :disabled="paymentMethod != 'cash' || $loading"
          />
        </b-form-group>
        <b-button
          variant="primary"
          type="submit"
          @click="makePaymentMP200"
          :disabled="btnDisabled || $loading"
          id="mp200-cont-btn"
          class="float-right mt-4"
        >
          <span v-if="!$loading">Continue</span>
          <b-spinner small v-if="$loading"></b-spinner>
        </b-button>
      </b-form>
      <div v-if="$loading == true" class="m-1">
        <h6 style="font-weight: normal;">Processing Payment</h6>
        <b-progress
          :value="100"
          variant="primary"
          striped
          animated
          class="mt-3"
        ></b-progress>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CustomerInfoCheckout from "../components/CustomerInfoCheckout";
import axios from "axios";
import * as msg from "../message";
import qz from "../printer";
import * as helper from "../helper";
// import moment from "moment";
import pinelabs from "../components/PineLabs";
// import db from "../database";
import CircularCountDownTimer from "../components/CircularCountDownTimer";
import PhonePe from "./PhonePe";
import RedeemVoucher from "./RedeemVoucher";
import _ from "lodash";
export default {
  name: "payment-methods",
  components: {
    CustomerInfoCheckout,
    pinelabs,
    CircularCountDownTimer,
    PhonePe,
    RedeemVoucher,
  },
  props: ["amount", "multiple"],
  data() {
    return {
      active: false,
      payAmt: "",
      refundAmt: "",
      payableAmt: "",
      paymentMethod: "",
      title: "",
      splitAmt: 0,
      changeData: customData,
      offlinePaymentName: "",
      mp200Output: "",
      mp200OutputStr: "",
      mp200PaymentStatus: "",
      isRequired: false,
      hideInfo: false,
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    customerShortData() {
      return this.$store.getters["billing/getCustomerDetails"];
    },
    getLayByAmt() {
      return parseFloat(this.state.billing.billing.layBy_Amt).toFixed(2);
    },
    getToTotalPaybale() {
      return parseFloat(this.state.billing.billing.total_payable).toFixed(2);
    },
    checkCoupon() {
      let data = false;
      if (typeof Android !== "undefined" && Android !== null) {
        data = true;
      }
      return data;
    },

    checkCash() {
      let data = false;
      this.state.system.settings.payment_type.map((item) => {
        if (item.name == "cash") {
          if (item.status == 1) {
            data = true;
          }
        }
      });
      return data;
    },
    checkOfflineType() {
      let data = [];
      this.state.system.settings.payment_type.map((item) => {
        if (item.type == "OFFLINE" && item.status == 1) {
          if (
            item.mop_name == "loyalty_emr" ||
            item.mop_name == "pinelab_internal" ||
            item.mop_name == "coupon" ||
            item.mop_name == "google_tez_offline" ||
            item.mop_name == "paytm_offline" ||
            item.mop_name == "card_offline" ||
            item.name == "google_tez_offline" ||
            item.name == "paytm_offline" ||
            item.name == "card_offline" ||
            item.mop_name == "ezswype" ||
            item.mop_name == "cash" ||
            item.mop_name == "phonepe_online" ||
            item.name.toLowerCase() == "gift_voucher"
          ) {
            // console.log(item.name);
          } else {
            data.push({
              display_name: item.display_name,
              name: item.name,
            });
          }
        }
      });
      return data;
    },
    paytmOffline() {
      let data = false;
      let popUpTitle = "";
      this.state.system.settings.payment_type.map((item) => {
        item.display_text = popUpTitle;
        if (item.name == "paytm_offline") {
          if (item.status == 1) {
            data = true;
          }
        }
      });
      return data;
    },
    googlePayOffline() {
      let data = false;
      this.state.system.settings.payment_type.map((item) => {
        if (item.name == "google_tez_offline") {
          if (item.status == 1) {
            data = true;
          }
        }
      });
      return data;
    },
    mp200Status() {
      let data = false;
      this.state.system.settings.payment_type.map((item) => {
        if (item.name == "ezswype") {
          if (item.status == 1) {
            data = true;
          }
        }
      });
      return data;
    },
    pinelabStatus() {
      let data = false;
      this.state.system.settings.payment_type.map((item) => {
        if (item.mop_name == "pinelab_internal") {
          if (item.status == 1) {
            data = true;
          }
        }
      });
      return data;
    },
    phonepeStatus() {
      let data = false;
      this.state.system.settings.payment_type.map((item) => {
        if (item.mop_name == "phonepe_online") {
          if (item.status == 1) {
            data = true;
          }
        }
      });
      return data;
    },
    checkCard() {
      let data = {
        status: false,
        type: "card",
      };
      this.state.system.settings.payment_type.map((item) => {
        if (item.name == "ezswype") {
          if (item.status == 1) {
            data.status = true;
            data.type = "ezswype";
          }
        }
      });
      if (!data.status) {
        this.state.system.settings.payment_type.map((item) => {
          if (item.name == "card_offline") {
            if (item.status == 1) {
              data.status = true;
              data.type = "card_offline";
            }
          }
        });
      }
      return data;
    },
    checkOnlinePayment() {
      let data = false;
      this.state.system.settings.payment_type.map((item) => {
        if (item.name == "razor_pay_online") {
          data = true;
        }
      });
      return data;
    },
    btnDisabled() {
      let check = true;
      if (this.paymentMethod == "cash") {
        if (parseFloat(this.payAmt) >= this.payableAmt) {
          // this.$refs.payAmt.focus()
          check = false;
        }
        if (this.multiple == true) {
          if (
            this.state.billing.billing.total_payable <= parseFloat(this.payAmt)
          )
            check = false;
        }
      } else {
        if (this.payableAmt == parseFloat(this.payAmt)) {
          check = false;
        }
      }
      if (this.$loading == true) {
        check = true;
      }
      if (this.payableAmt > this.state.billing.billing.total_payable) {
        check = true;
      }
      return check;
    },
    payableAmount() {
      return parseFloat(
        this.state.billing.billing.order.summary.total_payable
      ).toFixed(2);
    },
    paymentBntDisabled() {
      let check = false;
      if (this.payableAmt > this.state.billing.billing.total_payable) {
        check = true;
      } else if (this.payableAmt == 0) {
        check = true;
      }
      return check;
    },
    checkLayByAmt() {
      let layByAmt = this.state.billing.billing.layBy_Amt;
      if (this.state.billing.billing.layBy_Amt > 0) {
        if (this.state.billing.billing.order.data != "") {
          if (
            this.state.billing.billing.order.summary.amount_due != "0" &&
            this.state.billing.billing.order.data.transaction_sub_type ==
              "sales"
          ) {
            layByAmt = "";
            // console.log("cool");
          } else if (
            this.state.billing.billing.total_payable !=
              this.state.billing.billing.layBy_Amt &&
            this.state.billing.billing.order.data.transaction_sub_type ==
              "lay_by"
          ) {
            layByAmt = "";
          }
        }
      }
      return layByAmt;
    },
    getOrderIdLength() {
      let length = this.state.system.settings.vendor_app_menu.offline
        .offline_invoice_id_format.order_id.name.length;
      return length;
    },
    isOfflineEnabled() {
      let check = false;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1 &&
        this.state.system.isOffline == false
      ) {
        check = true;
      }
      return check;
    },
    refundMode() {
      let check = false;
      if (this.state.billing.billing.refund_mode) {
        check = true;
      }
      return check;
    },
    isOmsMiniAmount() {
      return this.$store.getters.isOmsMiniAmount;
    },
    isPayableInputEnabled() {
      // if(this.$store.getters.isOMSEnabled || this.multiple)
    },
    isOrderBtnEnabled() {
      if (
        parseFloat(this.state.billing.billing.order.summary.amount_paid) >=
        this.$store.getters.isOmsMiniAmount.amount
      ) {
        return false;
      } else {
        return true;
      }
    },
    orderMiniPayMsg() {
      return !this.isOrderBtnEnabled
        ? "Minimum order acceptance criteria fulfilled"
        : "Minimum order acceptance amount is ₹ " +
            this.$store.getters.isOmsMiniAmount.amount.toFixed(2);
    },
    transTypeRefundNote() {
      let check = false;
      if (this.state.billing.billing.order.data.trans_sub_type == "Refund-CN")
        check = true;
      return check;
    },
    gvStatus() {
      let temp = false;
      let gv = _.find(this.state.system.settings.payment_type, (item) => {
        return item.name == "gift_voucher";
      });

      if (gv) temp = true;

      return temp;
    },
    refundType() {
      return this.$store.getters["system/getRefundType"];
    },
  },
  watch: {
    payAmt() {
      if (this.payAmt == "") {
        this.refundAmt = "";
      } else if (this.multiple == true) {
        let refAmt = this.payAmt - this.payableAmt;
        if (refAmt > 0) {
          this.refundAmt = refAmt;
        } else {
          this.refundAmt = 0;
        }
      } else if (this.multiple == false) {
        let refAmt = this.payAmt - this.state.billing.billing.total_payable;
        if (refAmt > 0) {
          this.refundAmt = refAmt;
        } else {
          this.refundAmt = 0;
        }
      }
    },
    payableAmt() {
      this.$emit("pay-amt", this.payableAmt);
      if (this.state.billing.billing.invoice.data == "") {
        if (this.payableAmt > this.state.billing.billing.total_payable) {
          let alertData = {
            message: msg.BILL_AMT_GREATER,
            type: "danger",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
          // this.payableAmt = this.state.billing.total_payable.toFixed(2);
          //alert("Enter amount is grater then bill amount");
        }
      }
    },
    multiple() {
      if (this.multiple) {
        this.$nextTick(() => {
          this.$refs["amt-pay"].focus();
        });
      } else {
        this.payableAmt = parseFloat(
          this.state.billing.billing.total_payable
        ).toFixed(2);
      }
    },
    changeData: {
      handler(val) {
        let self = this;
        if (val.data.status == "mSwype_card_payment") {
          if (
            val.data.type.status == "Success" ||
            val.data.type.status == "Transaction Completed" ||
            val.data.type.status == "OK" ||
            val.data.type.status == "Ok"
          ) {
            console.log("After Success");
            self.cardPayment(val.data.type);
          }
        }
      },
      deep: true,
    },
    getLayByAmt() {
      this.payableAmt = this.state.billing.billing.layBy_Amt;
    },
    getToTotalPaybale(newCount, oldCount) {
      this.payableAmt = newCount;
    },
  },
  mounted() {
    this.payableAmt = parseFloat(
      this.state.billing.billing.total_payable
    ).toFixed(2);
    if (this.isOfflineEnabled) {
      helper.getInvoiceId("invoice_id");
      console.log(this.state.billing.billing.invoice_no);
      // order_id = this.state.billing.billing.invoice_no;
      // console.log(order_id);
      // order_id = invoice_id.substring(
      //   invoice_id.length - this.getOrderIdLength
      // );
      // return console.log(order_id);
    }
  },
  methods: {
    sendAmt() {
      this.$emit("pay-amt", this.payableAmt);
    },
    redeemLoyaltyPoints() {
      this.$loading = true;
      let self = this;
      let postData = {
        temp_order_id: this.state.billing.billing.cart.order_id,
        store_id: this.state.sessions.user.store_id,
        amount: this.state.billing.billing.total_payable,
        sub_total: this.state.billing.billing.subtotal,
        discount: this.state.billing.billing.discount,
        tax_total: this.state.billing.billing.taxes,
        total: this.state.billing.billing.total_payable,
        bill_buster_discount: "",
        employee_id: "",
        employee_discount: "",
        pay_by_voucher: "0.00",
        payment_gateway_type: "LOYALTY",
        bill_buster_id: "",
        manual_discount_factor: "",
        manual_discount_basis: "",
        manual_discount: "",
        transaction_sub_type: "",
        trans_from: this.state.system.trans_from,
        api_token: this.state.sessions.user.api_token,
        url: "/process-to-payment",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then((res) => {
          this.$loading = false;
          if (typeof Android !== "undefined" && Android !== null) {
            let postData = {
              type: "loyalty_emr",
              data: res.data.loyalty_url,
            };
            returnValue(postData);
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.$loading = false;
        });
    },
    openRefundModal(data) {
      // console.log(data);
      this.paymentMethod = data;
      this.title = data;
      this.payAmt = this.payableAmt;
      this.$refs["cash-modal"].show();
    },
    openCashModal(data) {
      this.paymentMethod = data;
      if (this.paymentMethod == "cash") {
        this.title = "Pay by Cash";
      }
      if (this.paymentMethod == "paytm_offline") {
        this.title = "Pay by Paytm";
      }
      if (
        this.paymentMethod == "card_offline" ||
        this.paymentMethod == "ezswype"
      ) {
        this.title = "Pay by Card";
      }
      if (this.paymentMethod == "google_tez_offline") {
        this.title = "Pay by Google Pay";
      }
      if (this.paymentMethod != "cash") {
        if (this.multiple) {
          this.payAmt = this.payableAmt;
        } else {
          this.payAmt = parseFloat(
            this.state.billing.billing.total_payable
          ).toFixed(2);
        }
      }
      this.$refs["cash-modal"].show();
    },

    openMP200Modal() {
      if (this.multiple) {
        this.payAmt = this.payableAmt;
      } else {
        this.payAmt = parseFloat(
          this.state.billing.billing.total_payable
        ).toFixed(2);
      }
      this.paymentMethod = "eswype_mp200";
      this.$refs["mp200-modal"].show();
      let delims = {
        start: "",
        end: "",
        width: null,
      };
      qz.serial.openPort(this.state.mp200Port, delims);
    },

    openOfflineModal(data, name) {
      this.title = data;
      this.paymentMethod = "offline";
      this.payAmt = this.multiple
        ? this.payableAmt
        : parseFloat(this.state.billing.billing.total_payable).toFixed(2);
      this.offlinePaymentName = name;
      this.$refs["cash-modal"].show();
    },
    makePayment() {
      // let invoice_id = "";
      let order_id = "";
      if (this.isOfflineEnabled) {
        // helper.getInvoiceId("invoice_id");
        order_id = this.state.billing.billing.invoice_no;
        console.log(order_id);
        order_id = order_id.substring(order_id.length - this.getOrderIdLength);
      }
      // if (typeof Android !== "undefined" && Android !== null) {
      //   let postData = { type: "print_invoice", data: res.data.print_data };
      //     returnValue(postData);
      // }
      if (this.paymentMethod == "ezswype" && this.checkCard.type == "ezswype") {
        console.log("Cart Payment");
        if (typeof Android !== "undefined" && Android !== null) {
          let data = {
            order_id: this.state.billing.billing.order.data.order_id,
            amount: this.payableAmt,
            device_user_name: this.state.system.paymentDeviceDetails.username,
            device_password: this.state.system.paymentDeviceDetails.password,
            device_name: this.state.system.paymentDeviceDetails.bluetooth_name,
            device_ble_address: this.state.system.paymentDeviceDetails
              .bluetooth_id,
            customer_name: this.customerShortData.name,
            customer_email: this.customerShortData.email,
            customer_number: this.customerShortData.mobile,
          };
          // console.log(data);
          let postData = {
            type: "mSwype_card_payment",
            data: data,
          };
          returnValue(postData);
        }
      } else {
        if (this.paymentMethod == "offline") {
          this.$loading = true;
          let cash = 0;
          if (this.paymentMethod == "cash") {
            cash = this.payAmt;
          }
          let postData = {
            amount: this.payableAmt,
            t_order_id: "",
            order_id: this.state.billing.billing.order.data.order_id,
            pay_id: "",
            method: this.offlinePaymentName,
            invoice_id: "",
            bank: "",
            wallet: "",
            vpa: "",
            error_description: "",
            status: "success",
            address_id: "",
            payment_gateway_status: this.paymentMethod.toUpperCase(),
            payment_gateway_type: this.offlinePaymentName,
            cash_collected: cash,
            cash_return: this.refundAmt,
            lay_by_total: this.checkLayByAmt,
            lay_by_remark: "",
            transaction_sub_type:
              this.state.billing.billing.layBy_Amt != 0 ? "lay_by" : "",
            url: "save-payment",
            gateway_response: "",
            payment_gateway_device_type: "",
            invoice_seq: order_id,
            remark: this.state.billing.billing.remark,
          };
          let data = Object.assign(
            postData,
            this.essentialsData,
            this.customerData
          );
          this.$store
            .dispatch("billing/savePayment", data)
            .then((res) => {
              this.$loading = false;
              if (
                this.state.billing.billing.total_payable == 0 ||
                this.state.billing.billing.total_payable == "0.00"
              ) {
                if (this.isOfflineEnabled) {
                  this.$store.dispatch("billing/saveInvoiceId");
                }
                this.$store.commit("billing/resetBilling");
              }
              if (res.data.status == "validation") {
                let alertData = {
                  message: res.data.message,
                  type: "danger",
                };
                this.$showAlert = true;
                this.$store.commit("notifications/showAlert", alertData);
              }
              this.$refs["cash-modal"].hide();
            })
            .catch((err) => {
              this.$loading = false;
              // console.log(err.response);
              // let alertData = {
              //   message: msg.INTERNAL_SERVER_ERROR,
              //   type: "danger"
              // };
              // this.$store.commit("showAlert", alertData);
              // this.$bvModal.msgBoxOk(err.response.data.message);
            });
        } else {
          this.$loading = true;
          let cash = 0;
          if (this.paymentMethod == "cash") {
            cash = this.payAmt;
          }
          let postData = {
            amount: this.payableAmt,
            t_order_id: "",
            order_id: this.state.billing.billing.order.data.order_id,
            pay_id: "",
            method: this.paymentMethod.toLowerCase(),
            invoice_id: "",
            bank: "",
            wallet: "",
            vpa: "",
            error_description: "",
            status: "success",
            address_id: "",
            payment_gateway_type: this.paymentMethod.toUpperCase(),
            cash_collected: cash,
            cash_return: this.refundAmt,
            lay_by_total: this.checkLayByAmt,
            lay_by_remark: "",
            transaction_sub_type:
              this.state.billing.billing.layBy_Amt != 0 ? "lay_by" : "",
            url: "save-payment",
            gateway_response: "",
            payment_gateway_device_type: "",
            invoice_seq: order_id,
            remark: this.state.billing.billing.remark,
            // trans_type: this.refundMode ? "return" : "",
            credit_issue: this.refundMode
              ? this.paymentMethod.toLowerCase()
              : "",
          };
          let data = Object.assign(
            postData,
            this.essentialsData,
            this.customerData
          );
          this.$store
            .dispatch("billing/savePayment", data)
            .then((res) => {
              this.$loading = false;
              if (
                this.state.billing.billing.total_payable == 0 ||
                this.state.billing.billing.total_payable == "0.00"
              ) {
                if (this.isOfflineEnabled) {
                  this.$store.dispatch("billing/saveInvoiceId");
                }
                this.$store.commit("billing/resetBilling");
              }
              if (res.data.status == "validation") {
                let alertData = {
                  message: res.data.message,
                  type: "danger",
                };
                this.$showAlert = true;
                this.$store.commit("notifications/showAlert", alertData);
              }
              this.$refs["cash-modal"].hide();
            })
            .catch((err) => {
              this.$loading = false;
              // this.$refs["cash-modal"].hide();
              // console.log(err.response);
              // let alertData = {
              //   message: msg.INTERNAL_SERVER_ERROR,
              //   type: "danger"
              // };
              // this.$store.commit("showAlert", alertData);
              // this.$bvModal.msgBoxOk(err.response.data.message);
            });
        }
      }
    },
    closeCashModal() {
      this.$refs["cash-modal"].hide();
    },
    clearData() {
      // if (!this.multiple) {
      this.payAmt = "";
      this.refundAmt = "";
      // }
    },
    cardPayment(val) {
      let order_id = "";
      if (this.isOfflineEnabled) {
        order_id = this.state.billing.billing.invoice_no;
        console.log(order_id);
        order_id = order_id.substring(order_id.length - this.getOrderIdLength);
      }
      let postData = {
        amount: val.amount,
        t_order_id: "",
        order_id: this.state.billing.billing.order.data.order_id,
        pay_id: val.transaction_id,
        method: val.payment_mode.toLowerCase(),
        invoice_id: "",
        bank: "",
        wallet: "",
        vpa: "",
        error_description: "",
        status: "success",
        address_id: "",
        payment_gateway_type: "EZSWYPE",
        cash_collected: "",
        cash_return: "",
        lay_by_total: this.checkLayByAmt,
        lay_by_remark: "",
        transaction_sub_type:
          this.state.billing.billing.layBy_Amt != 0 ? "lay_by" : "",
        url: "save-payment",
        gateway_response: JSON.stringify(val),
        payment_gateway_device_type: "",
        remark: this.state.billing.billing.remark,
        invoice_seq: order_id,
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      this.$store
        .dispatch("billing/savePayment", data)
        .then((res) => {
          this.$loading = false;
          if (
            this.state.billing.billing.total_payable == 0 ||
            this.state.billing.billing.total_payable == "0.00"
          ) {
            if (this.isOfflineEnabled) {
              this.$store.dispatch("billing/saveInvoiceId");
            }
            this.$store.commit("billing/resetBilling");
          }
          this.$refs["cash-modal"].hide();
        })
        .catch((err) => {
          console.log(err.response);
          this.$$loading = false;
          // this.$refs["cash-modal"].hide();
        });
    },
    makePaymentMP200() {
      console.log("[MP200]");
      this.$loading = true;
      var response = "";
      // var newstr = "";
      var data = [
        {
          BillInvoiceNumber: this.state.billing.billing.order.data.order_id,
          TransType: "2",
          Amount: this.payAmt,
          CurrencyCode: "INR",
          MobNum: this.state.billing.billing.customer.data.mobile,
        },
      ];

      qz.serial.sendData(this.state.system.mp200Port, data);
      qz.serial.setSerialCallbacks((evt) => {
        console.log("waiting");
        if (evt.output.length > 4) {
          response = evt.output;
          response = response.trim();
          if (response[response.length - 3] == ",") {
            this.mp200Output = response.substring(0, newstr.length - 3) + "}";
            this.mp200OutputStr =
              response.substring(0, newstr.length - 3) + "}";
            this.mp200Output = JSON.parse(this.mp200Output);
            qz.serial.closePort(this.state.system.mp200Port);
            this.savePaymentMP200();
          } else {
            this.mp200Output = JSON.parse(response);
            this.mp200OutputStr = response;
            qz.serial.closePort(this.state.system.mp200Port);
            this.savePaymentMP200();
          }
          // if (this.mp200Output.ResMsg == "Approved or Completed Successfully") {
          // } else {
          //   alert("payment failed " + this.mp200Output.RespMsg);
          // }
        }
        // this.$loading = false;
        // if (evt.output.length > 4) {
        //   response = evt.output;
        //   response = response.trim();
        //   this.mp200Output = response.substring(0, response.length - 5) + "}";
        //   this.mp200Output = JSON.parse(this.mp200Output);
        //   console.log(this.mp200Output);
        // }
      });
    },
    savePaymentMP200() {
      let order_id = "";
      if (this.isOfflineEnabled) {
        // helper.getInvoiceId("invoice_id");
        order_id = this.state.billing.billing.invoice_no;
        order_id = order_id.substring(order_id.length - this.getOrderIdLength);
      }
      if (this.mp200Output.RespMsg == "Approved or Completed Successfully") {
        this.mp200PaymentStatus = this.mp200Output.RespMsg;
        console.log("save-payment-mp200");
        let postData = {
          amount: this.payAmt,
          t_order_id: "",
          order_id: this.state.billing.billing.order.data.order_id,
          pay_id: this.mp200Output.TxnID,
          method: "card",
          invoice_id: "",
          bank: "",
          wallet: "",
          vpa: "",
          error_description: "",
          status: "success",
          address_id: "",
          payment_gateway_type: "EZSWYPE",
          cash_collected: "",
          cash_return: "",
          lay_by_total: this.checkLayByAmt,
          lay_by_remark: "",
          transaction_sub_type:
            this.state.billing.billing.layBy_Amt != 0 ? "lay_by" : "",
          url: "save-payment",
          gateway_response: this.mp200OutputStr,
          payment_gateway_device_type: "MP200",
          remark: this.state.billing.billing.remark,
          invoice_seq: order_id,
        };
        let data = Object.assign(
          postData,
          this.essentialsData,
          this.customerData
        );
        this.$store
          .dispatch("savePayment", data)
          .then((res) => {
            this.$loading = false;
            if (
              this.state.billing.billing.total_payable == 0 ||
              this.state.billing.billing.total_payable == "0.00"
            ) {
              if (this.isOfflineEnabled) {
                this.$store.dispatch("billing/saveInvoiceId");
              }
              this.$store.commit("billing/resetBilling");
            }
            this.$refs["mp200-modal"].hide();
            let alertData = {
              message: this.mp200PaymentStatus,
              type: "success",
            };
            this.$showAlert = true;
            // this.$store.commit("resetAlert");
            this.$store.commit("notifications/showAlert", alertData);
          })
          .catch((err) => {
            this.$loading = false;
            // this.$refs["mp200-modal"].hide();
            if (err != "" || err != undefined) {
              console.log(err);
            }
          });
      } else {
        console.log("Payment Failed Error:- " + this.mp200Output.RespMsg);
        this.mp200PaymentStatus = "Payment Failed: " + this.mp200Output.RespMsg;
        let postData = {
          amount: this.payAmt,
          t_order_id: "",
          order_id: this.state.billing.billing.order.data.order_id,
          pay_id: this.mp200Output.TxnID,
          method: "card",
          invoice_id: "",
          bank: "",
          wallet: "",
          vpa: "",
          error_description: "",
          status: "error",
          address_id: "",
          payment_gateway_type: "EZSWYPE",
          cash_collected: "",
          cash_return: "",
          lay_by_total: this.checkLayByAmt,
          lay_by_remark: "",
          transaction_sub_type:
            this.state.billing.billing.layBy_Amt != 0 ? "lay_by" : "",
          url: "save-payment",
          gateway_response: this.mp200OutputStr,
          payment_gateway_device_type: "MP200",
          remark: this.state.billing.billing.remark,
        };
        let data = Object.assign(
          postData,
          this.essentialsData,
          this.customerData
        );
        this.$store
          .dispatch("billing/savePayment", data)
          .then((res) => {
            this.$loading = false;
            if (
              this.state.billing.billing.total_payable == 0 ||
              this.state.billing.billing.total_payable == "0.00"
            ) {
              this.$store.commit("billing/resetBilling");
            }
            this.$refs["mp200-modal"].hide();
            let alertData = {
              message: this.mp200PaymentStatus,
              type: "danger",
            };
            this.$showAlert = true;
            // this.$store.commit("resetAlert");
            this.$store.commit("notifications/showAlert", alertData);
          })
          .catch((err) => {
            this.$loading = false;
            // this.$refs["mp200-modal"].hide();
            if (err != "" || err != undefined) {
              console.log(err);
            }
          });
      }
    },
  },
  beforeDestroy() {
    if (
      this.state.billing.auto_print_enable &&
      this.$store.getters.checkInvoiceSuccess
    )
      this.$store.commit("billing/printMode", 1);
  },
};
</script>
<style lang="scss" scoped>
// .fadeHeight-enter-active,
// .fadeHeight-leave-active {
//   transition: all 0.2s;
//   max-height: 345px;
//   overflow:hidden;
// }
// .fadeHeight-enter,
// .fadeHeight-leave-to
// {
//   opacity: 0;
//   max-height: 0px;
// }

.theme-dark .btn-white {
  color: #c0c0c0 !important;
}
.theme-light .payment-page label {
  color: #606060 !important;
  font-size: 14px;
}
/* input:read-only {
  background-color: transparent !important;
  border: 1px #606060 solid !important;
} */
.pay input:last-child:read-only {
  background-color: transparent !important;
  border: 1px #c0c0c0 solid !important;
  color: #808080;
}
.btn-outline-secondary.dropdown-toggle:active {
  background: #76767680;
  border: 1px #76767680 solid;
}
.amtpay {
  color: #848484;
}
.payment-page .py-2 {
  padding-bottom: 0.8rem !important;
  padding-top: 0.8rem !important;
}
.payment-page .h-25 {
  height: 40px !important;
}

// .bg-black {
//   background-color: #000;
//   border: 1px #606060 solid;
//   color: #fff;
// }
// .theme-light .bg-black {
//   background-color: transparent;
//   border: 1px #c0c0c0 solid;
//   color: #404040;
// }
h6 {
  font-size: 0.875rem;
  margin: 0px;
  font-weight: 500;
}
// .form-notification {
//   border: 1px solid $primary-color;
//   background-color: #eef9ff;
//   .input-group-text {
//     border: none !important;
//     background-color: transparent;
//     svg {
//       color: #336699;
//     }
//   }
//   .form-control {
//     border: none !important;
//     font-size: 14px;
//     padding-left: 0;
//     color: #336699;
//     background-color: transparent;
//   }
// }
.active-from-notification {
  border: 1px solid ;
  background-color: #fff;
  .input-group-text {
    svg {
      color: $green-color
    }
  }
  .form-control {
    color: $green-color
  }
}
/* .payment-page {
  .scroll {
    height: calc(100vh - 514px);
    overflow-y: auto;
    overflow-x: hidden;
    @include custom-scrollbar();
  }
} */

.paybtns-row,
.custom-methods {
  .col-md-6:nth-child(odd) {
    padding-right: 0.25rem;
  }
  .col-md-6:nth-child(even) {
    padding-left: 0.25rem;
  }
}
</style>
